<template>
  <div class="RowLine">
    <div class="RowLine-left">
      <!-- 进度 -->
      <div class="RowLine-left-block">
        <div class="desc longTouch">{{ desc }}</div>
        <div class="progress">
          <div class="progress-text longTouch">
            {{ progressFormat(cur_progress, total_level) }}
          </div>
          <div
            class="progress-line"
            :class="{ man: divWidth === '100%' }"
            :style="{ width: divWidth }"
          ></div>
        </div>
      </div>
      <!-- 图片 -->
      <div class="RowLine-left-box">
        <PropItem
        :prop_number="kep_num"
        :prop_img="require('@/assets/images/YuliApp/weeklyTask/goods_icon_kep@2x.png')"
        ></PropItem>
        <!-- 奖励 -->
        <!-- <img
          class="icon"
          :src="
            require('@/assets/images/YuliApp/weeklyTask/goods_icon_kep@2x.png')
          "
        />
        <div class="number longTouch">{{ kep_num }}</div> -->
      </div>
    </div>
    <div class="RowLine-right">
      <!-- 完成待领取 -->
      <div
        class="RowLine-right-claim longTouch"
        v-if="taskState === TASK_STATE.CLAIM"
        @click="debounce(handleClaim, 400)()"
      >
        <div class="RowLine-right-button active">{{localesPackage?.['katharsis_claim_button']?.[localesEnv]}}</div>
      </div>

      <!--已领取 -->
      <div class="RowLine-right-yes" v-if="taskState === TASK_STATE.CLAIMED">
        <img
          :src="require('@/assets/images/YuliApp/weeklyTask/btn_task_yes.svg')"
        />
      </div>

      <!-- 进行中未完成 -->
      <div
        class="RowLine-right-inProgress"
        v-if="taskState === TASK_STATE.IN_PROGRESS"
      >
        <div class="RowLine-right-button">{{localesPackage?.['katharsis_claim_button']?.[localesEnv]}}</div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  onBeforeMount,
  onMounted,
  ref,
  computed,
  getCurrentInstance,
} from "vue";
import { TASK_STATE_TYPE, ERROR_TEXT } from "@/constants/enums";
import audioManager from "@/utils/audioManager";
import {
  getTaskReward,
  postRewardClaim,
  postExpClaim,
} from "@/api/weeklyTask.js";
import _ from "lodash";
import { tofix } from "@/utils/utils";
import { TOAST_TYPE } from "../../../../../Toast/index.vue";
import PropItem from "../../../MessagePopup/components/PropItem";
import { mapState } from "vuex";

export default {
  components: {
      PropItem
  },
  props: {
    desc: {
      type: String,
      default: "Log in",
    },
    cur_progress: {
      type: Number,
      default: 2,
    },
    total_level: {
      type: Number,
      default: 3,
    },
    task_state: {
      type: Number,
      default: 1,
    },
    task_id: {
      type: String,
      default: "",
    },
    // task_kep: {
    //   type: Number,
    //   default: 0,
    // },
    kep_num: {
      type: Number,
      default: 0,
    },
    period_id: {
      type: String,
      default: "",
    },
    mission_item: {
      type: Object,
      default: null,
    },
    isClaiming: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState({
      languageEnv: (state) => state.global.languageEnv,
      languagePackage: (state) => state.global.languagePackage,
    }),
  },
  watch: {
    task_state: {
      handler(value) {
        this.taskState = value;
      },
      immediate: true,
      deep: true,
    },
    cur_progress: {
      handler(value) {
        this.handleProgress(value, this.total_level);
      },
      immediate: true,
      deep: true,
    },
    mission_item: {
      handler(value) {
        this.missionItem = value;
      },
      immediate: true,
      deep: true,
    },
    isClaiming: {
      handler(value) {
        this.claimingState = value;
      },
      immediate: true,
      deep: true,
    },
    languageEnv: {
      async handler(value) {
        if(value){
          this.localesEnv = value;
        }
      },
      immediate: true,
      deep: true,
    },
    languagePackage: {
      async handler(value) {
        if(value){
          this.localesPackage = value;
        }
      },
      immediate: true,
      deep: true,
    }
  },
  setup(props, { emit }) {
    const { proxy } = getCurrentInstance();
    /**语言包 - ref */
    const localesPackage = ref({});
    /**语言环境 - ref */
    const localesEnv = ref('en');
    const { period_id, task_id, task_state, kep_num } = props;
    const divWidth = ref(0);
    const TASK_STATE = ref(TASK_STATE_TYPE);
    const taskState = ref(0);
    const missionItem = ref(null);
    const taskKep = ref(0);
    const claimingState = ref(false);

    onMounted(() => {});

    /**
     * 任务进度文本展示格式化
     */
    const progressFormat = computed(() => {
      return (cur_progress, total_level) => {
        let cur = cur_progress;
        let total = total_level;
        try {
          // 单独处理步数
          if (total_level >= 1000) {
            if (cur < 100) {
              cur = `0k`;
            } else {
              const remain = cur % 1000;
              const divisor = cur / 1000;
              cur = `${tofix(divisor, remain > 0 ? 1 : 0)}k`;
            }
            total = `${total_level / 1000}k`;
          }
          return `${cur}/${total}`;
        } catch (error) {
          return `${cur}/${total}`;
        }
      };
    });

    /**
     * 计算当前进度条的长度
     */
    const handleProgress = (cur_progress, total_level) => {
      if (cur_progress >= total_level) {
        divWidth.value = "100%";
      } else {
        let nowValue = Number(((cur_progress / total_level) * 100).toFixed(2));
        if( nowValue < 4 && nowValue !== 0)nowValue = 4;
        divWidth.value = nowValue + "%";
      }
    };

    /**
     * 防抖
     */
    function debounce(fun, delay) {
      return function (args) {
        let that = this;
        let _args = args;
        clearTimeout(fun.id);
        fun.id = setTimeout(function () {
          fun.call(that, _args);
        }, delay);
      };
    }

    /**
     * 处理claim按钮领取奖励
     * state为1表领取成功
     * state为2表已领取
     * state为0表还没完成任务
     */
    const handleClaim = async () => {
      if (claimingState.value) {
        return;
      }
      emit("claiming", true);

      audioManager.playEffect("bubble");

      proxy.$loading.show();

      const { result, state } = await requestDrawKep();

      proxy.$loading.hide();

      if (result && state === 1) {
        // console.log("领取成功");
        taskState.value = 2;
        emit("handleMissionsClaim", task_id, kep_num, missionItem.value);
        setTimeout(() => {
          audioManager.playEffect("expget");
        }, 200);
      } else {
        emit("claiming", false);
        // console.log("领取失败", taskState.value);
        proxy.$toast.show({
          msg: localesPackage.value?.['katharsis_toast_msg1']?.[localesEnv.value],
          type: TOAST_TYPE.ERROR,
        });
      }
    };

    /**
     * 请求领取经验值
     */
    const requestDrawKep = () => {
      const param = {
        mission_id: Number(task_id),
        period_id: period_id,
      };
      return postExpClaim(param)
        .then((res) => {
          const state = _.get(res, "data.state", 0);
          // console.log("state", res);
          return { result: true, state: state };
        })
        .catch((error) => {
          return { result: false, state: 0 };
        });
    };

    return {
      divWidth,
      TASK_STATE,
      taskState,
      missionItem,
      handleClaim,
      handleProgress,
      taskKep,
      debounce,
      progressFormat,
      claimingState,
      localesPackage,
      localesEnv
    };
  },
};
</script>

<style lang="less" scoped>
//阻止长按操作
.longTouch {
  -webkit-touch-callout: none; /*系统默认菜单被禁用*/
  -webkit-user-select: none; /*webkit浏览器*/
  -khtml-user-select: none; /*早期浏览器*/
  -moz-user-select: none; /*火狐*/
  -ms-user-select: none; /*IE10*/
  user-select: none;
}
.RowLine {
  width: 350px;
  min-height: 70px;
  background: url("~@/assets/images/YuliApp/weeklyTask/rewardline-bg.png")
    no-repeat top left;
  background-size: 100% 100%;
  margin-bottom: 12px;

  display: flex;
  justify-content: space-between;
  align-items: center;
  &-left {
    padding-right: 14px;
    box-sizing: border-box;
    height: 100%;
    width: 271px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    &-block {
      //   margin-top: 15.5px;
      margin-left: 19px;
      .desc {
        width: 182px;
        // color: rgba(184, 191, 217, 1);
        color: #fff;
        font-size: 16px;
        font-weight: 500;
        font-family: "PingFang SC";
        text-align: left;
        line-height: 18px;

        margin-bottom: 7px;
      }
      .progress {
        position: relative;
        box-sizing: border-box;
        width: 67px;
        height: 16px;
        border-radius: 20px;
        opacity: 1;
        background: #D0C9FD;
        border: 1px solid #D0C9FD;
        padding: 1px;
        &-line {
          border-radius: 20px;
          height: 100%;
          background: #50459E;
        }
        .man {
          border-radius: 20px;
        }
        &-text {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%,-50%);
          color: rgba(255, 255, 255, 1);
          font-size: 12px;
          font-weight: 500;
          font-family: "PingFang SC";
          text-align: center;
          line-height: 100%;

          text-shadow: 0 1px #000, 1px 0 #000, -1px 0 #000, 0 -1px #000;
        }
      }
    }
    &-box {
      position: relative;
      width: 52px;
      height: 52px;
      // background: url("~@/assets/images/YuliApp/weeklyTask/reward_block_bg.svg")
      //   no-repeat top left;
      // background-size: 100% 100%;
      div{
        scale: 0.8;
        margin: unset;
        top: -6px;
        left: -6px;
      }
      .icon {
        width: 43px;
        height: 43px;
        object-fit: cover;
      }
      .number {
        // margin: -16px auto 0 auto;
        width: 89%;
        height: 14.73px;

        margin-left: 49%;
        margin-top: -16px;
        transform: translate(-50%, 0);

        background: url("~@/assets/images/YuliApp/weeklyTask/reward_block_bg_2.svg")
          no-repeat top left;
        background-size: 100% 100%;

        color: rgba(255, 255, 255, 1);
        font-size: 12px;
        font-weight: 400;
        font-family: "PingFang HK";
        text-align: center;
        line-height: 14.4px;
        letter-spacing: 0.72px;
      }
    }
  }
  &-right {
    &-button{
      width: 70px;
      height: 26px;
      border-radius: 20px;
      border: 1px solid rgba(0, 0, 0, 0.1);
      background: #babbc0ff;  
      color: #ffffffff;
      font-size: 13px;
      font-weight: 600;
      font-family: "PingFang SC";
      text-align: center;
      line-height: 26px;
    }
    .active{
      background: #423B6A;
    }
    &-claim {
      margin-right: 2px;
      width: 76px;
      height: 34px;
      // background: url("~@/assets/images/YuliApp/weeklyTask/button_claim@2x.png")
      //   no-repeat top left;
      // background-size: 100% 100%;

      color: rgba(218, 227, 235, 1);
      font-size: 15px;
      font-weight: 500;
      font-family: "PingFang HK";
      text-align: center;
      line-height: 34px;
    }
    &-yes {
      padding-top: 3px;
      padding-right: 3px;
      width: 76px;
      height: 100%;
      img {
        width: 32px;
        height: 32px;
      }
    }
    &-inProgress {
      padding-right: 2px;
      width: 76px;
      height: 100%;
      opacity: 1;
      color: rgba(105, 117, 150, 1);
      font-size: 12px;
      font-weight: 500;
      font-family: "PingFang HK";
      text-align: center;
      line-height: 100%;
    }
  }
}
</style>
